import { useEffect, useRef, useState } from 'react';
import api from '../lib/api.js';

/**
 * Sign-in screen, replacing the legacy default.aspx.
 *
 * Credentials are checked by dbo.FSWeb_Login2, so every existing FSWeb account
 * works unchanged. Where the deployment also offers Windows SSO, the browser
 * will already have been signed in before this screen is reached; it only
 * appears for accounts without a Windows identity.
 */
export default function Login({ mode, onSignedIn }) {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const first = useRef(null);

  useEffect(() => { first.current?.focus(); }, []);

  async function submit(e) {
    e?.preventDefault();
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      await api.post('/auth/login', { userId: userId.trim(), password });
      setPassword('');
      onSignedIn();
    } catch (err) {
      setError(err);
      setPassword('');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={submit}>
        <div className="login-brand">
          <div className="login-company">{mode?.company || 'FSWeb'}</div>
          <div className="login-sub">Factoring &amp; receivables management</div>
        </div>

        {error && (
          <div className="msg error" role="alert">
            {error.message}
          </div>
        )}

        <div className="field">
          <label htmlFor="login-user">User login id</label>
          <input
            id="login-user"
            ref={first}
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            autoComplete="username"
            autoCapitalize="off"
            spellCheck="false"
            disabled={busy}
          />
        </div>

        <div className="field">
          <label htmlFor="login-pass">Password</label>
          <input
            id="login-pass"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            disabled={busy}
          />
        </div>

        <button className="btn primary login-submit" type="submit" disabled={busy || !userId.trim() || !password}>
          {busy ? <><span className="spinner" /> Signing in...</> : 'Sign in'}
        </button>

        {mode?.windows && (
          <div className="login-note">
            Staff accounts are signed in automatically with their Windows login. If you were not, use the form above.
          </div>
        )}

        <div className="login-foot">
          <span>{mode?.copyright}</span>
          {mode?.env && mode.env !== 'production' && <span className="pill warn">{mode.env}</span>}
        </div>
      </form>
    </div>
  );
}
